<template>
  <div class="pro-page auto">
    <div class="imgbox auto"><img :src="url + '/ncity/index/speed_index_01.jpg?v=2'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/ncity/index/speed_index_02.jpg?v=2'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/ncity/index/speed_index_03.jpg?v=2'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/ncity/index/speed_index_04.jpg?v=3'" alt=""></div>
    <!-- <div class="imgbox auto"><img v-lazy="url + '/ncity/index/speed_index_05.jpg'" alt=""></div> -->

    <!-- <div class="fixed-btn auto">
      <img :src="url + '/ncity/index/fixed_btn.png'" alt="">
    </div> -->

    <div class="footer auto">
      <div class="nlounge-btn atuo">
        <img :src="url + '/ncity/index/btn1.png'" id="nlounge-btn" alt="">
      </div>
      <div class="nlounge-btn atuo">
        <img :src="url + '/ncity/index/btn2.png'" id="nlounge-btn-my" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import Config from '@/conf'
export default {
  data () {
    return {
      // url: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images'
      url: Config.root + '/elantra_n_client_activity/images',
      showUpdate: false,
      NVersion: 0
    }
  },
  mounted(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        this.$wx.miniProgram.getEnv((res)=>{
           if (res.miniprogram) {
              // alert("在小程序里");
              document.querySelector('#nlounge-btn').addEventListener('click', () => {
                this.$wx.miniProgram.navigateTo({
                  url: '/pages/ncenter/speed'
                })
              })
              document.querySelector('#nlounge-btn-my').addEventListener('click', () => {
                this.$wx.miniProgram.navigateTo({
                  url: '/pages/ncenter/myspeed'
                })
              })

              this.$wx.miniProgram.postMessage({
                data: {
                  title: 'N速度高分挑战赛 等你来刷！'
                }
              })

           } else {
               console.log("不在小程序里");
           }
        })
    }else{
      // let search = this.$util.deserialize(window.location.search && window.location.search.slice(1))
      // this.NVersion = search['NVersion']
      // if (!search['NVersion'] || Number(search['NVersion']) < 136) {
      //   this.showUpdate = true
      // }
      console.log(this.$route.query)
      this.NVersion = this.$route.query['NVersion']
      if (!this.$route.query['NVersion'] || Number(this.$route.query['NVersion']) < 136) {
        // this.showUpdate = true
      }
      // alert('不在微信里');
      document.addEventListener('UniAppJSBridgeReady', function() {
        document.querySelector('#nlounge-btn').addEventListener('click', function() {
          if (window.uni) {
            window.uni.navigateTo({
              url: '/pages/ncenter/speed'
            })
          }
        })
        document.querySelector('#nlounge-btn-my').addEventListener('click', function() {
          if (window.uni) {
            window.uni.navigateTo({
              url: '/pages/ncenter/myspeed'
            })
          }
        })
      })
    }
  },
  methods: {
    goDownload () {
      this.$router.push('/download')
    }
  }
}
</script>

<style lang="scss" scoped>
.pro-page {
  background: #000;
  padding-bottom: 30vw;
}
.nlounge-btn {
  img {
    width: 79.6vw;
    margin: 0 auto;
  }
}

.footer {
  padding: 5vw 0 8vw;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  .nlounge-btn {
    width: 42vw;
    img {
      width: 100%;
    }
  }
  .nlounge-btn:nth-child(2) {
    margin-left: 3vw;
  }
}


.tips-alert {
	position: fixed;
	display: flex;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, .76);
	z-index: 999;
	align-items: center;
	justify-content: center;
}
.tips-alert-content {
	width: 84%;
	.tips-title{
		height: 50px;
		background: #fff;
		text-align: center;
		line-height: 50px;
		font-size: 17px;
		color: #000;
	}
	.tips-content {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		color: #000;
		background: #fff;
		padding: 0 10%;
		height: 115px;
		// text-align: center;
	}
	.tips-btn-box {
		display: flex;
		background: #fff;
		padding-bottom: 16px;
		justify-content: center;
		gap: 13px;
		.tips-btn {
			width: 35%;
			text-align: center;
			background: #c2d6f0;
			height: 40px;
			color: #000;
			font-size: 15px;
			line-height: 40px;
		}
		.cur {
			background: #e33521;
			color: #fff;
		}
	}
  .tips-btn-boxbetween {
    // justify-content: space-between;
    .tips-btn {
      margin: 0 3vw;
    }
  }
}
.tips-btn-cancel {
	background: #fff;
	text-align: center;
	color: #666;
	font-size: 12px;
	padding-bottom: 20px;
	text-decoration: underline;
}

.fixed-btn {
  width: 12vw;
  position: fixed;
  right: 6.4vw;
  bottom: 30vw;
}
</style>